// An order line's two notes.
const clean = (value) => String(value ?? "").trim();

// The shipper's note on the product for this order (the line's `note`, from
// creating or editing the order or creating its shipment): how to pick, pack
// or deliver it. The warehouse and the driver see it and never change it.
export const productNote = (item) => clean(item?.note);

// What the warehouse or the driver wrote while fulfilling it, e.g. why some
// of it is still to come.
export const fulfilmentNote = (item) => clean(item?.fulfillment_note);
